export default __webpack_public_path__ + "static/media/cc.6da7b8e6.svg";